// @ts-nocheck
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Main from './components/Main/Main';
import AppTheme from './AppTheme';
import { isIPad13 } from 'react-device-detect';
import { ApplicationContext } from './contexts/ApplicationContext';
import { AppConfig } from './contexts/AppConfig';
import { store } from './store';
import { ThemeProvider } from '@mui/material';
import Restaurant from './components/Branch/Branch';
import OTP from '@src/pages/public-pages/order/otp/index';
import OrderDetails from './pages/public-pages/order';
import Page404 from './pages/404';
import ReleaseNotes from './pages/public-pages/release-notes';
import Register from './pages/Register';

const App = ({ config, apiService }) => {
	// const { isMobileScreen } = useAppSelector((state) => state.UI);
	const supplliersPaths = [
		'/suppliers/:id/orders/allOrders',
		'/suppliers/:id/orders/acceptDelivery',
		'/suppliers/:id',
		'/suppliers/:id/chat/:waId',
		'/suppliers/:id/chat/:waId/message/:msgId',
		'/suppliers/:id/catalogs/',
		'/suppliers/:id/catalogs/add',
		'/suppliers/:id/catalogs/edit/:catalogId',
		'/suppliers/:id/productCatalog',
		'/suppliers/:id/productCatalog/add',
		'/suppliers/:id/productCatalog/edit/:productId',
		'/suppliers/:id/:waId/editOrder/:orderId',
		'/suppliers/:id/settings/general',
		'/suppliers/:id/settings/branch',
		'/suppliers/:id/settings/teams&permissions',
		'/suppliers/:id/settings/integrations',
		'/suppliers/:id/ai-insights',
		'/suppliers/:id/finance',
		'/marketplace/storeFront/:supplierId',
		'/suppliers/:id/settings/tallyApproval',
		'/marketplace/storeFront/:supplierId/product/:productId',
		'/suppliers/:id/rewards/dashboard',
		'/suppliers/:id/rewards/settings',
		'/suppliers/:id/rewards/settings/add',
		'/suppliers/:id/rewards/customer-wallet',
		'/suppliers/:id/customers/list',
		'/suppliers/:id/customers/creditLimit',
	];
	const restaurantPaths = [
		'/restaurants/:id/orders',
		'/restaurants/:id/chat/:waId',
		'/restaurants/:id/chat/:waId/message/:msgId',
		'/restaurants/:id/orders/allOrders',
		'/restaurants/:id/orders/acceptDelivery',
		'/restaurants/:id/:waId/editOrder/:orderId',
		'/restaurants/:id',
		'/:id',
		'/restaurants/:id/settings/general',
		'/restaurants/:id/settings/branch',
		'/restaurants/:id/settings/teams&permissions',
		'/restaurants/:id/settings/branch',
		'/restaurants/:id/settings/integrations',
		'/restaurants/:id/ai-insights',
		'/restaurants/:id/finance',
		'/marketplace/explore',
		'/marketplace/explore/:productId',
		'/marketplace/browseSuppliers',
		'/marketplace/storeFront/:supplierId',
		'/marketplace/storeFront/:supplierId/product/:productId',
		'/restaurants/:id/rewards/dashboard',
	];

	const redirectUrls = {
		d1v7hn6auu0rdo: 'https://web.cheeni.ai/',
		d320ad107nabyb: 'https://web-stage.cheeni.ai/',
		d2rh02tlce5e5h: 'https://web-test.cheeni.ai/',
	};

	const redirectBasedOnHost = () => {
		let host = '';
		if (typeof window !== 'undefined') {
			host = window.location.host.split('.')?.[0];
			const redirectUrl = redirectUrls[host];
			if (redirectUrl) {
				window.location.href = redirectUrl;
			}
		}
	};

	useEffect(() => {
		redirectBasedOnHost();
	}, []);

	const renderPaths = (paths, Element) =>
		paths.map((path) => <Route key={path} path={path} element={Element} />);
	return (
		<Provider store={store}>
			<ThemeProvider theme={AppTheme}>
				<div className={'app absoluteFullscreen' + (isIPad13 ? ' absoluteFullscreen' : '')}>
					<AppConfig.Provider value={config}>
						<ApplicationContext.Provider
							value={{
								apiService,
							}}
						>
							<Router>
								<Routes>
									<Route path="/restaurants" element={<Restaurant />} />
									<Route path="/suppliers" element={<Restaurant />} />
									{renderPaths(
										[
											...supplliersPaths,
											...restaurantPaths,
											// '/dashboard',
											//'/chats/:id/:waId',
											//'/chats/:id/:waId/message/:msgId',
											// '/restaurants/:id/marketplace/explore',
											// '/restaurants/:id/marketplace/suppliers',
											// '/restaurants/:id/marketplace/explore/:productId',
										],
										<Main />
									)}
									{renderPaths(
										['/login', 'login/error', '/login/error/:errorCase', '/'],
										<Login />
									)}
									{/* Public Routes */}
									<Route path="/register" element={<Register />} />
									<Route path="/404" element={<Page404 />} />
									<Route path="/public/order/:instanceId" element={<OTP />} />
									<Route path="/public/order/:instanceId/details" element={<OrderDetails />} />
									{/* <Route path="/release-notes" element={<ReleaseNotes />} /> */}
									<Route path="*" element={<Navigate to="/404" />} />
								</Routes>
							</Router>
						</ApplicationContext.Provider>
					</AppConfig.Provider>
				</div>
			</ThemeProvider>
		</Provider>
	);
};

export default App;
